module.exports = __webpack_public_path__ + "static/media/text-bg.e3e67b63.svg";